/* eslint-disable max-params, no-param-reassign -- these linting errors come up constantly with reducers */

import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import type { RootState } from "@/store";
import { useAppDispatch } from "@/store/hooks";
import { extraReducersFactory } from "@/store/reducers/reset";
import type { EventDetailsProps } from "@/ui/components/schedule/details/EventDetails";

interface ScheduleEventDetailsData {
  appointmentMetaData?: AppointmentDetailResponse;
  eventDetails: EventDetailsProps;
  isUpcomingEvent?: boolean;
  selectedUserId?: string;
  title: string;
}

interface ScheduleEventDetailsModalSliceState {
  scheduleEventDetailsData?: ScheduleEventDetailsData;
}

const initialState: ScheduleEventDetailsModalSliceState = {
  scheduleEventDetailsData: undefined,
};

const scheduleEventDetailsModalSlice = createSlice({
  // NOTE: extraReducers is required for resetAllReduxSlices to work as expected
  extraReducers: extraReducersFactory(initialState),
  initialState,
  name: "scheduleEventDetailsModal",
  reducers: {
    resetScheduleEventDetailsData: (state) => {
      state.scheduleEventDetailsData = undefined;
    },
    setScheduleEventDetailsData: (
      state,
      action: PayloadAction<ScheduleEventDetailsData>,
    ) => {
      state.scheduleEventDetailsData = action.payload;
    },
  },
});

const {
  resetScheduleEventDetailsData: resetScheduleEventDetailsDataAction,
  setScheduleEventDetailsData: setScheduleEventDetailsDataAction,
} = scheduleEventDetailsModalSlice.actions;

const selectScheduleEventDetailsData = (state: RootState) =>
  state.scheduleEventDetailsModal.scheduleEventDetailsData;

const useScheduleEventDetailsModalDispatch = () => {
  const dispatch = useAppDispatch();

  const resetScheduleEventDetailsData = () => {
    dispatch(resetScheduleEventDetailsDataAction());
  };

  const setScheduleEventDetailsData = (data: ScheduleEventDetailsData) => {
    dispatch(setScheduleEventDetailsDataAction(data));
  };

  return {
    resetScheduleEventDetailsData,
    setScheduleEventDetailsData,
  };
};

export { selectScheduleEventDetailsData, useScheduleEventDetailsModalDispatch };
export type { ScheduleEventDetailsData };
export default scheduleEventDetailsModalSlice.reducer;
